export type PaginationItem = number | "ellipsis";

/** Zero-based page indexes, with gaps represented by an ellipsis. */
export function getPaginationItems(pageCount: number, currentPage: number, maxItems: number): PaginationItem[] {
  if (pageCount <= 0) return [];
  if (pageCount <= maxItems) return Array.from({ length: pageCount }, (_, page) => page);

  const lastPage = pageCount - 1;
  const edgePages = maxItems - 2;
  if (currentPage <= edgePages - 1) {
    return [...Array.from({ length: edgePages }, (_, page) => page), "ellipsis", lastPage];
  }
  if (currentPage >= lastPage - edgePages + 1) {
    return [0, "ellipsis", ...Array.from({ length: edgePages }, (_, index) => lastPage - edgePages + 1 + index)];
  }

  const middlePages = maxItems - 4;
  const start = currentPage - Math.floor((middlePages - 1) / 2);
  return [
    0,
    "ellipsis",
    ...Array.from({ length: middlePages }, (_, index) => start + index),
    "ellipsis",
    lastPage,
  ];
}
